import { render, staticRenderFns } from "./multiline_comment_form.vue?vue&type=template&id=6269f91c&"
import script from "./multiline_comment_form.vue?vue&type=script&lang=js&"
export * from "./multiline_comment_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports